import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const WaIcon = ({ size = 6 }) => (
  <svg className={`w-${size} h-${size}`} fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const IgIcon = ({ size = 5 }) => (
  <svg className={`w-${size} h-${size}`} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const FbIcon = ({ size = 5 }) => (
  <svg className={`w-${size} h-${size}`} fill="currentColor" viewBox="0 0 24 24">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const TtIcon = ({ size = 5 }) => (
  <svg className={`w-${size} h-${size}`} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
);

const ALL_SERVICES = [
  { id: 'mantenimiento', icon: '🔧', title: 'Mantenimiento Preventivo', desc: 'Cambio de aceite, filtros y revision general del vehiculo.' },
  { id: 'mecanica',      icon: '⚙️', title: 'Mecanica General',         desc: 'Motor, transmision, frenos y sistema de suspension.' },
  { id: 'electrico',     icon: '⚡', title: 'Sistema Electrico',         desc: 'Diagnostico computarizado y reparacion electrica.' },
  { id: 'aireacond',     icon: '❄️', title: 'Aire Acondicionado',        desc: 'Carga de gas, limpieza y reparacion del sistema.' },
  { id: 'diagnostico',   icon: '🔍', title: 'Diagnostico Profesional',   desc: 'Scanner de ultima generacion para detectar fallas.' },
  { id: 'lavado',        icon: '✨', title: 'Lavado y Detailing',         desc: 'Limpieza interior y exterior con productos premium.' },
  { id: 'alineacion',    icon: '🎯', title: 'Alineacion y Balanceo',      desc: 'Correccion de angulos y equilibrio de ruedas.' },
  { id: 'llantas',       icon: '🔵', title: 'Llantas y Rines',            desc: 'Venta, montaje y reparacion de llantas.' },
  { id: 'latoneria',     icon: '🎨', title: 'Latoneria y Pintura',        desc: 'Reparacion de golpes y pintura profesional.' },
  { id: 'frenos',        icon: '🛑', title: 'Sistema de Frenos',          desc: 'Pastillas, discos, liquido y calibradores.' },
  { id: 'transmision',   icon: '🔩', title: 'Transmision',                desc: 'Caja automatica, mecanica y diferencial.' },
  { id: 'suspension',    icon: '🚗', title: 'Suspension y Direccion',     desc: 'Amortiguadores, rotulas y direccion hidraulica.' },
  { id: 'vidrios',       icon: '🪟', title: 'Vidrios y Polarizado',       desc: 'Instalacion y reparacion de vidrios.' },
  { id: 'escape',        icon: '💨', title: 'Escape y Turbo',             desc: 'Sistema de escape, catalizadores y turbo.' },
  { id: 'bateria',       icon: '🔋', title: 'Baterias',                   desc: 'Venta, carga y mantenimiento de baterias.' },
];

// Convierte hex a rgb para poder usar con opacidad
const hexToRgb = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `${r}, ${g}, ${b}`;
};

const WorkshopLanding = () => {
  const { slug } = useParams();
  const [workshop, setWorkshop] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWorkshopData = async () => {
      try {
        const { data, error } = await supabase
          .from('workshops')
          .select('*')
          .eq('slug', slug)
          .single();
        if (error) throw error;
        setWorkshop(data);
      } catch (error) {
        console.error('Error cargando el taller:', error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchWorkshopData();
  }, [slug]);

  if (loading) return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white text-lg font-medium">Cargando tu taller...</p>
      </div>
    </div>
  );

  if (!workshop) return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <p className="text-white text-lg">Taller no encontrado.</p>
    </div>
  );

  const primary   = workshop.brand_color_primary   || '#1e293b';
  const secondary = workshop.brand_color_secondary || '#3b82f6';
  const heroImg   = workshop.hero_image_url || 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=1920&q=80';
  const agendaUrl = `https://agenda.filtrosyaceitesjm.com/login?workshopId=${workshop.id}`;
  const waNum     = workshop.whatsapp ? workshop.whatsapp.replace(/\D/g, '') : null;
  const waUrl     = waNum ? `https://wa.me/${waNum}` : null;
  const fmt       = (t) => t ? t.slice(0, 5) : '';

  const rgbPrimary   = hexToRgb(primary);
  const rgbSecondary = hexToRgb(secondary);

  // Servicios seleccionados
  const savedIds = Array.isArray(workshop.services) && workshop.services.length > 0
    ? workshop.services : null;
  const SERVICES = savedIds
    ? ALL_SERVICES.filter(s => savedIds.includes(s.id))
    : ALL_SERVICES.slice(0, 6);

  // Grid adaptativo al numero de servicios
  const count = SERVICES.length;
  const gridClass = count <= 3
    ? 'grid-cols-1 sm:grid-cols-3'
    : count <= 6
      ? 'grid-cols-2 md:grid-cols-3'
      : count <= 9
        ? 'grid-cols-2 md:grid-cols-3 lg:grid-cols-3'
        : 'grid-cols-2 md:grid-cols-4 lg:grid-cols-5';
  const cardPad = count >= 10 ? 'p-4' : 'p-6';

  return (
    <div className="min-h-screen bg-white font-sans" id="ws-root">

      {/* ── CSS DINAMICO CON LOS COLORES DEL TALLER ── */}
      <style>{`
        /* Variables de marca */
        #ws-root {
          --p: ${primary};
          --s: ${secondary};
          --p-rgb: ${rgbPrimary};
          --s-rgb: ${rgbSecondary};
        }

        /* Tarjetas de servicio */
        .ws-card {
          border: 2px solid transparent;
          transition: all 0.25s ease;
          background: white;
        }
        .ws-card:hover {
          border-color: rgba(${rgbSecondary}, 0.6);
          box-shadow: 0 12px 32px rgba(${rgbSecondary}, 0.18);
          transform: translateY(-3px);
        }

        /* Icono dentro de la tarjeta */
        .ws-icon-bg {
          background-color: rgba(${rgbPrimary}, 0.10);
          transition: background-color 0.25s ease;
        }
        .ws-card:hover .ws-icon-bg {
          background-color: rgba(${rgbSecondary}, 1);
        }

        /* Titulo de tarjeta al hover */
        .ws-card:hover .ws-card-title {
          color: ${secondary};
        }

        /* Etiqueta de seccion */
        .ws-label {
          color: ${secondary};
        }

        /* Barra decorativa bajo titulos */
        .ws-bar {
          background: linear-gradient(90deg, ${secondary}, ${primary});
        }

        /* Boton outline */
        .ws-btn-outline {
          border: 2px solid rgba(255,255,255,0.45);
          backdrop-filter: blur(4px);
          transition: background-color 0.2s;
        }
        .ws-btn-outline:hover {
          background-color: rgba(255,255,255,0.12);
        }

        /* Stat card */
        .ws-stat {
          border: 1.5px solid rgba(${rgbSecondary}, 0.20);
          transition: all 0.2s ease;
        }
        .ws-stat:hover {
          border-color: rgba(${rgbSecondary}, 0.55);
          box-shadow: 0 4px 16px rgba(${rgbSecondary}, 0.12);
        }
        .ws-stat-num {
          color: ${secondary};
        }

        /* CTA strip */
        .ws-cta {
          background: linear-gradient(135deg, ${primary} 0%, ${secondary} 100%);
        }

        /* Footer tint */
        .ws-footer {
          background: linear-gradient(180deg, #0a0f1e 0%, #0f172a 60%, #111827 100%);
        }

        /* Footer glow accent */
        .ws-footer-glow {
          background: linear-gradient(90deg, transparent, rgba(${rgbSecondary}, 0.15), transparent);
        }

        /* Footer CTA block */
        .ws-footer-cta {
          background: linear-gradient(135deg, rgba(${rgbSecondary}, 0.12), rgba(${rgbPrimary}, 0.20));
          border: 1px solid rgba(${rgbSecondary}, 0.25);
        }

        /* Social button hover glow */
        .ws-social-btn {
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .ws-social-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0,0,0,0.4);
        }

        /* Footer divider line */
        .ws-footer-divider {
          background: linear-gradient(90deg, transparent, rgba(${rgbSecondary}, 0.5), transparent);
          height: 1px;
        }

        /* Nav scrolled */
        .ws-nav {
          background-color: ${primary};
          transition: box-shadow 0.3s;
        }

        /* Scroll suave */
        html { scroll-behavior: smooth; }
      `}</style>

      {/* ─── NAV ─── */}
      <nav className="ws-nav sticky top-0 z-50 shadow-xl">
        <div className="max-w-6xl mx-auto px-5 py-4 flex items-center justify-between">
          <span className="text-white font-black italic uppercase tracking-tight text-xl">{workshop.name}</span>
          <div className="flex items-center gap-3">
            {waUrl && (
              <a href={waUrl} target="_blank" rel="noreferrer"
                className="ws-btn-outline hidden sm:flex items-center gap-2 px-4 py-2 rounded-full text-white text-sm font-semibold">
                <WaIcon size={4} /> WhatsApp
              </a>
            )}
            <a href={agendaUrl}
              className="px-5 py-2.5 rounded-full text-white text-sm font-black shadow-lg hover:opacity-90 transition-all hover:scale-105"
              style={{ backgroundColor: secondary }}>
              Agendar Cita →
            </a>
          </div>
        </div>
      </nav>

      {/* ─── HERO ─── */}
      <section
        className="relative min-h-screen flex items-center justify-center text-center overflow-hidden"
        style={{
          backgroundImage: `url(${heroImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      >
        {/* Overlay con los colores exactos del taller */}
        <div className="absolute inset-0" style={{
          background: `linear-gradient(135deg,
            rgba(${rgbPrimary}, 0.93) 0%,
            rgba(${rgbPrimary}, 0.75) 40%,
            rgba(0,0,0,0.60) 100%)`
        }} />

        <div className="relative z-10 max-w-4xl mx-auto px-6 py-32">
          {/* Badge live */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/20 text-white/90 text-sm font-medium mb-8"
            style={{ backgroundColor: `rgba(${rgbSecondary}, 0.20)` }}>
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse inline-block"></span>
            {workshop.city}, Colombia &mdash; Agenda disponible ahora
          </div>

          <h1 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight drop-shadow-lg">
            {workshop.hero_title || `Expertos en mecanica automotriz en ${workshop.city}`}
          </h1>
          <p className="text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed">
            {workshop.hero_description || `En ${workshop.name} cuidamos tu vehiculo con la mejor tecnologia y garantia en cada trabajo.`}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href={agendaUrl}
              className="w-full sm:w-auto px-9 py-4 rounded-full text-white font-black text-lg shadow-2xl hover:scale-105 transition-transform"
              style={{ backgroundColor: secondary }}>
              Agendar Cita Online →
            </a>
            {waUrl && (
              <a href={waUrl} target="_blank" rel="noreferrer"
                className="ws-btn-outline w-full sm:w-auto flex items-center justify-center gap-2 px-9 py-4 rounded-full text-white font-bold text-lg">
                <WaIcon size={5} /> Escribir por WhatsApp
              </a>
            )}
          </div>

          <div className="mt-16 text-white/40 text-xs animate-bounce">↓ Ver servicios</div>
        </div>
      </section>

      {/* ─── STATS ─── */}
      <section className="py-10 bg-gray-50 border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-5 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { val: '100%', label: 'Servicio Garantizado' },
            { val: 'Hoy',  label: 'Atencion disponible' },
            { val: '✓',    label: 'Tecnicos Certificados' },
            { val: '0$',   label: 'Diagnostico incluido' },
          ].map((s, i) => (
            <div key={i} className="ws-stat bg-white rounded-2xl px-5 py-4 text-center">
              <div className="ws-stat-num text-2xl font-black mb-0.5">{s.val}</div>
              <div className="text-gray-400 text-xs font-medium">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ─── SERVICIOS ─── */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-5">
          <div className="text-center mb-12">
            <span className="ws-label text-xs font-black uppercase tracking-widest">Lo que hacemos</span>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mt-2 mb-3">Nuestros Servicios</h2>
            <div className="ws-bar h-1 w-14 mx-auto rounded-full"></div>
            <p className="text-gray-400 mt-4 max-w-xl mx-auto text-sm">
              Atencion profesional para todo tipo de vehiculos con equipos de diagnostico de ultima generacion.
            </p>
          </div>

          <div className={`grid ${gridClass} gap-5`}>
            {SERVICES.map((s) => (
              <div key={s.id} className={`ws-card rounded-2xl ${cardPad} shadow-sm cursor-default`}>
                <div className="ws-icon-bg w-12 h-12 rounded-xl flex items-center justify-center mb-4">
                  <span className="text-2xl">{s.icon}</span>
                </div>
                <h3 className="ws-card-title font-bold text-gray-900 text-sm mb-1.5 transition-colors">{s.title}</h3>
                <p className="text-gray-400 text-xs leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── CTA BANNER ─── */}
      <section className="ws-cta py-20 px-5 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
            Listo para agendar tu cita?
          </h2>
          <p className="text-white/80 mb-8 text-lg">
            Agenda en linea en menos de 2 minutos. Sin llamadas, sin esperas.
          </p>
          <a href={agendaUrl}
            className="inline-block px-10 py-4 bg-white rounded-full font-black text-lg hover:scale-105 transition-transform shadow-2xl"
            style={{ color: primary }}>
            Reservar mi Cita Ahora →
          </a>
        </div>
      </section>

      {/* ─── FOOTER ─── */}
      <footer className="ws-footer text-gray-400">

        {/* Franja superior de color */}
        <div className="h-1 w-full" style={{ background: `linear-gradient(90deg, ${primary}, ${secondary}, ${primary})` }} />

        {/* Bloque CTA central superior */}
        <div className="ws-footer-glow py-14 px-5 text-center">
          <div className="max-w-2xl mx-auto ws-footer-cta rounded-3xl px-8 py-10">
            <p className="text-xs uppercase tracking-widest font-bold mb-2" style={{ color: secondary }}>
              Agenda en minutos
            </p>
            <h3 className="text-2xl md:text-3xl font-black text-white mb-2 leading-tight">
              Tu vehiculo nos importa
            </h3>
            <p className="text-gray-400 text-sm mb-6">
              Reserva tu cita online ahora mismo, sin esperas ni llamadas.
            </p>
            <a href={agendaUrl}
              className="inline-block px-9 py-3.5 rounded-full text-white font-black text-sm shadow-2xl hover:scale-105 transition-transform"
              style={{ backgroundColor: secondary }}>
              Agendar mi Cita →
            </a>
          </div>
        </div>

        {/* Divisor */}
        <div className="ws-footer-divider mx-auto w-3/4" />

        {/* Grid info */}
        <div className="max-w-6xl mx-auto px-5 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

            {/* Col 1 — brand */}
            <div>
              <span className="text-white font-black italic uppercase tracking-tight text-2xl block mb-3"
                style={{ textShadow: `0 0 30px rgba(${rgbSecondary}, 0.4)` }}>
                {workshop.name}
              </span>
              <p className="text-sm leading-relaxed text-gray-500 mb-5">
                {workshop.footer_tagline || `Tu taller de confianza en ${workshop.city}. Calidad y garantia en cada servicio.`}
              </p>
              {SERVICES.length > 0 && (
                <div className="flex flex-wrap gap-1.5">
                  {SERVICES.slice(0, 5).map(s => (
                    <span key={s.id}
                      className="text-xs px-2.5 py-1 rounded-full font-medium text-white/80"
                      style={{ backgroundColor: `rgba(${rgbSecondary}, 0.18)`, border: `1px solid rgba(${rgbSecondary}, 0.25)` }}>
                      {s.icon} {s.title.split(' ')[0]}
                    </span>
                  ))}
                  {SERVICES.length > 5 && (
                    <span className="text-xs px-2.5 py-1 rounded-full font-medium text-gray-600 border border-gray-700">
                      +{SERVICES.length - 5} mas
                    </span>
                  )}
                </div>
              )}
            </div>

            {/* Col 2 — contacto */}
            <div>
              <h4 className="text-white font-bold mb-5 text-xs uppercase tracking-widest flex items-center gap-2">
                <span className="inline-block w-4 h-0.5" style={{ backgroundColor: secondary }} />
                Contacto
              </h4>
              <ul className="space-y-3 text-sm">
                <li className="flex items-center gap-2.5 text-gray-300">
                  <span className="text-base">📞</span>
                  <span className="font-semibold text-white">{workshop.phone}</span>
                </li>
                <li className="flex items-start gap-2.5 text-gray-400">
                  <span className="text-base mt-0.5">📍</span>
                  <span>{workshop.address}, {workshop.city}</span>
                </li>
                {workshop.opening_time && (
                  <li className="flex items-center gap-2.5 text-gray-400">
                    <span className="text-base">🕐</span>
                    <span>{fmt(workshop.opening_time)} – {fmt(workshop.closing_time)}</span>
                  </li>
                )}
              </ul>
            </div>

            {/* Col 3 — redes sociales */}
            <div>
              <h4 className="text-white font-bold mb-5 text-xs uppercase tracking-widest flex items-center gap-2">
                <span className="inline-block w-4 h-0.5" style={{ backgroundColor: secondary }} />
                Siguenos
              </h4>
              <div className="flex flex-wrap gap-2.5">
                {waUrl && (
                  <a href={waUrl} target="_blank" rel="noreferrer"
                    className="ws-social-btn inline-flex items-center gap-2 px-4 py-2.5 bg-green-600 hover:bg-green-500 text-white text-xs font-bold rounded-xl">
                    <WaIcon size={4} /> WhatsApp
                  </a>
                )}
                {workshop.instagram && (
                  <a href={workshop.instagram} target="_blank" rel="noreferrer"
                    className="ws-social-btn inline-flex items-center gap-2 px-4 py-2.5 text-white text-xs font-bold rounded-xl"
                    style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}>
                    <IgIcon size={4} /> Instagram
                  </a>
                )}
                {workshop.facebook && (
                  <a href={workshop.facebook} target="_blank" rel="noreferrer"
                    className="ws-social-btn inline-flex items-center gap-2 px-4 py-2.5 bg-blue-700 hover:bg-blue-600 text-white text-xs font-bold rounded-xl">
                    <FbIcon size={4} /> Facebook
                  </a>
                )}
                {workshop.tiktok && (
                  <a href={workshop.tiktok} target="_blank" rel="noreferrer"
                    className="ws-social-btn inline-flex items-center gap-2 px-4 py-2.5 text-white text-xs font-bold rounded-xl border border-gray-600"
                    style={{ background: 'linear-gradient(135deg, #010101, #2a2a2a)' }}>
                    <TtIcon size={4} /> TikTok
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800/60">
          <div className="max-w-6xl mx-auto px-5 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-600">
            <span>© {new Date().getFullYear()} {workshop.name} &middot; {workshop.city}, Colombia</span>
            <span>Potenciado por <span className="font-bold" style={{ color: secondary }}>Garaje Pro 360</span></span>
          </div>
        </div>
      </footer>

      {/* ─── WhatsApp FAB ─── */}
      {waUrl && (
        <a href={waUrl} target="_blank" rel="noreferrer"
          className="fixed bottom-6 right-6 w-14 h-14 bg-green-500 hover:bg-green-400 rounded-full flex items-center justify-center shadow-2xl transition-transform hover:scale-110 z-50 text-white">
          <WaIcon size={7} />
        </a>
      )}
    </div>
  );
};

export default WorkshopLanding;
